import { useTranslation } from 'react-i18next'
import heroImg from '../../assets/img/hero-photo-2.png'
import npMarkImg from '../../assets/img/np-mark.png'
import { ButtonElement, ButtonLocation, trackButtonClick } from '../../utils/analyticsEvents'
import { Button } from '../Button/Button'
import { Icon, type IconName } from '../Icon/Icon'
import styles from './Hero.module.scss'

interface HeroBadge {
  highlighted?: boolean
  icon: IconName
  key: string
}

const BADGES: HeroBadge[] = [
  { highlighted: true, icon: 'box', key: 'discount' },
  { icon: 'clock', key: 'noQueue' },
  { icon: 'pin', key: 'nearby' },
  { icon: 'pin', key: 'tracking' },
]

interface HeroProps {
  onGetPromo: () => void
}

const renderMultiline = (text: string) =>
  text.split('\n').map((line, index) => (
    <span key={line}>
      {index > 0 ? <br /> : null}
      {line}
    </span>
  ))

export const Hero = ({ onGetPromo }: HeroProps) => {
  const { t } = useTranslation()

  return (
    <section className={styles.hero} id="top">
      <div className={styles.inner}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            <span className={styles.accent}>{renderMultiline(t('hero.titleAccent'))}</span>
            <br />
            {t('hero.titleRest')}
          </h1>
          <p className={styles.subtitle}>{t('hero.subtitle')}</p>
          <ul className={styles.badges}>
            {BADGES.map((badge) => (
              <li
                key={badge.key}
                className={`${styles.badge}${badge.highlighted ? ` ${styles.highlighted}` : ''}`}
              >
                <Icon name={badge.icon} size={24} />
                <span>{t(`hero.badges.${badge.key}`)}</span>
              </li>
            ))}
          </ul>
          <Button
            animated
            arrow
            hoverBlend
            className={styles.cta}
            onClick={() => {
              trackButtonClick(ButtonElement.GetPromocode, ButtonLocation.Hero)
              onGetPromo()
            }}
          >
            {t('hero.cta')}
          </Button>
        </div>
        <div className={styles.media}>
          <img
            alt={t('hero.imageAlt')}
            className={styles.photo}
            height="482"
            src={heroImg}
            width="777"
          />
          <div className={styles.bubble}>
            <img alt="" height="24" src={npMarkImg} width="24" />
            <span>{t('hero.bubble')}</span>
          </div>
        </div>
      </div>
    </section>
  )
}
